var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:new Date().getTime(),attrs:{"id":"api"}},[_c('iframe',{staticClass:"apiframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"frameborder":"0","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }